module.exports = __webpack_public_path__ + "static/about-profile-jonb-afb49537eb1633f254f7f14957bed086.png";